
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypePassengerOutlined as ObiVesselTypePassengerOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-passenger-outlined.js';
 
 
 

 
 export const ObiVesselTypePassengerOutlined = createComponent({
   react: React,
   tagName: 'obi-vessel-type-passenger-outlined',
   elementClass: ObiVesselTypePassengerOutlinedElement,
   events: {
     
   }
  });
 
 